export default __webpack_public_path__ + "static/media/Green_Storeys_Master_Plan .5e6b6c89.pdf";